import { Injectable } from '@angular/core';
import { Http, Response, Headers, ResponseContentType } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { CONFIGURATION } from '../app.config';

@Injectable()
export class AuditreportService {

  private auditreportUrl = CONFIGURATION.basefile1094CURL;
  private _ssnUrl = CONFIGURATION.baseServiceUrl + 'SsnInfo/';


  constructor(private _http: Http) { }

  getReportData(): Observable<any> {
    const headers = new Headers();
    headers.append('Client-Id', 'REPORTING-PORTAL-API-CLIENT');
    headers.append('Client-Secret', '0667b514-28a8-4928-9aa4-1ffe290ebcd2');
    return this._http.get(this.auditreportUrl + 'audit-report/tax-year', { headers: headers })
      .map((res: Response) => res.json())
      .catch(this.handleError);
  }
  getControlgroupData(selectedYear: any): Observable<any> {
    const headers = new Headers();
    headers.append('Client-Id', 'REPORTING-PORTAL-API-CLIENT');
    headers.append('Client-Secret', '0667b514-28a8-4928-9aa4-1ffe290ebcd2');
    return this._http.get(this.auditreportUrl + `audit-report/control-group?taxYear=${selectedYear}`, { headers: headers })
      .map((res: Response) => res.json())
      .catch(this.handleError);
  }
  getEligibleFullData(filterCriteria: any): Observable<any> {
    const headers = new Headers();
    headers.append('Client-Id', 'REPORTING-PORTAL-API-CLIENT');
    headers.append('Client-Secret', '0667b514-28a8-4928-9aa4-1ffe290ebcd2');
    return this._http.get(this.auditreportUrl + `audit-report/report-data?taxYear=${filterCriteria.selectedYear}&controlGroup=${filterCriteria.selectedControlGroup}`, { headers: headers })
      .map((res: Response) => res.json())
      .catch(this.handleError);
  }

  downloadPDFReport(filterCriteria: any): any {
    let fileName = 'audit-report/downloadPdf?taxYear=' + filterCriteria.selectedYear + '&controlGroup=' + filterCriteria.selectedControlGroup;
    const url = this.auditreportUrl + fileName
    const headers = new Headers();
    headers.append('Client-Id', 'REPORTING-PORTAL-API-CLIENT');
    headers.append('Client-Secret', '0667b514-28a8-4928-9aa4-1ffe290ebcd2');
    return this._http.get(this.auditreportUrl + fileName, { headers: headers, responseType: ResponseContentType.Blob }).map(
        (res) => {
            const a = document.createElement('a');
            document.body.appendChild(a);
            const blob = new Blob([res.blob()], { type: 'application/zip' });
            const downloadUrl = URL.createObjectURL(blob);
            window.open(downloadUrl);
        })
}
downloadExcelReport(filterCriteria: any): any {
  console.log(filterCriteria)
    let fileName = 'audit-report/downloadExcel?taxYear=' + filterCriteria.selectedYear + '&controlGroup=' + filterCriteria.selectedControlGroup;
    const url = this.auditreportUrl + fileName
    const headers = new Headers();
    headers.append('Client-Id', 'REPORTING-PORTAL-API-CLIENT');
    headers.append('Client-Secret', '0667b514-28a8-4928-9aa4-1ffe290ebcd2');
    return this._http.get(this.auditreportUrl + fileName, { headers: headers, responseType: ResponseContentType.Blob }).map(
        (res) => {
            const a = document.createElement('a');
            document.body.appendChild(a);
            const blob = new Blob([res.blob()], { type: 'application/zip' });
            const downloadUrl = URL.createObjectURL(blob);
            window.open(downloadUrl);
        })
}

  private handleError(error: Response) {
    // in a real world app, we may send the server to some remote logging infrastructure
    // instead of just logging it to the console
    console.error(error);
    return Observable.throw(error.json().error || 'Failed in web api(Server error) ');
  }

}


// WEBPACK FOOTER //
// ./src/app/auditreport/auditreport.service.ts